<template>
  <v-container fluid :class="{'lg-container': isBiggerThanMd, 'md-container': !isBiggerThanMd}">
    <img v-show="isLoading" src="../../assets/loading.gif" />
    <div class="py-5 mt-2" v-show="!isLoading">
      <p class="mt-0 text-left font-weight-bold ranking-title">コントリビュータランキング</p>
        <v-lazy>
          <v-tabs color="black" height="2rem">
            <v-tab
              class="rankingTab font-weight-bold"
              v-for="(rankingName, index) in rankingNameList"
              :key="index"
              @click="setRankingName(index)"
            >
              {{ rankingName }}
            </v-tab>
          </v-tabs>
        </v-lazy>
      <v-row v-show="isEmpty" class="mt-3">
        <v-col class="d-flex align-center justify-center">
          {{ emptyMsg }}
        </v-col>
      </v-row>
      <v-simple-table v-show="!isEmpty" class="mt-3">
        <tbody>
          <tr
            v-for="(ranking, index) in rankingList[type]"
            :key="index"
            @click="toUserDetail(ranking.user_code)"
          >
            <td class="text-left">
              <v-btn v-if="ranking.rank === 1" fab width="24" height="24" depressed>
                <v-img src="../../assets/trophy_rank1.svg"></v-img>
              </v-btn>
              <v-btn v-else-if="ranking.rank === 2" fab width="24" height="24" depressed>
                <v-img src="../../assets/trophy_rank2.svg"></v-img>
              </v-btn>
              <v-btn v-else-if="ranking.rank === 3" fab width="24" height="24" depressed>
                <v-img src="../../assets/trophy_rank3.svg"></v-img>
              </v-btn>
              <v-btn v-else fab width="24" height="24" depressed>
                {{ ranking.rank }}
              </v-btn>
              <span width="24" height="24" depressed class="font-weight-bold">
                {{ ranking.user_name }}
              </span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "ContributorRankingTable",
  data() {
    return {
      type: "dailyRanking",
      rankingTypeList: [
        "dailyRanking",
        "weeklyRanking",
        "monthlyRanking",
        "allRanking",
      ],
      activeTabIndex: null,
      rankingNameList: ["日間", "週間", "月間", "全て"],
      rankingList: [],
      isLoading: true,
      selectedButton: 0,
      isEmpty: false,
      emptyMsg: "",
    };
  },
  async mounted() {
    await this.getRanking();
    this.activeTabIndex = 0;
  },
  methods: {
    getRanking() {
      this.$store
        .dispatch("contributorRanking/get")
        .then(() => {
          this.rankingList =
            this.$store.getters["contributorRanking/rankingList"];
          this.setRank();
        })
        .finally(() => {
          this.setIsEmpty();
          this.isLoading = false;
        });
    },
    setRank() {
      for (const ranking in this.rankingList) {
				let rank = 1;
        for (let i = 0; i < this.rankingList[ranking].length; ++i) {
          if (
            i > 0 &&
            this.rankingList[ranking][i].ability <
              this.rankingList[ranking][i - 1].ability
          ) {
            ++rank;
          }
					this.rankingList[ranking][i].rank = rank;
        }
      }
    },
    setRankingName(index) {
      this.type = this.rankingTypeList[index];
      this.selectedButton = index;
      this.setIsEmpty();
    },
    isSelectedButton(index) {
      if (index === this.selectedButton) {
        return true;
      }
      return false;
    },
    toUserDetail(userCode) {
      this.$router.push(`/user/${userCode}`);
    },
    setIsEmpty() {
      if (this.rankingList[this.type].length === 0) {
        this.isEmpty = true;
        this.emptyMsg = `${
          this.rankingNameList[this.selectedButton]
        }のランキングは存在しません`;
      } else {
        this.isEmpty = false;
        this.emptyMsg = "";
      }
    },
  },
  computed: {
    isBiggerThanMd() {
      let isBigger = true;
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          isBigger = false;
          break;
        case 'sm':
          isBigger = false;
          break;
        case 'md':
          isBigger = true;
          break;
        case 'lg':
          isBigger = true;
          break;
        case 'xl':
          isBigger = true;
          break;
        default:
          break;
      }
      return isBigger;
    }
  }
};
</script>
<style lang="scss" scoped>
tr {
  cursor: pointer;
}
.rankingTab {
  padding: 0 !important;
  min-width: 3rem !important;
}
td {
  border-bottom: 1px solid #EDEDED;
}
.ranking-title {
  border-bottom: 2px solid #D0D0D0;
  padding-bottom: 6px;
}
.lg-container {
  width: 268px;
  min-width: 268px;
  padding: 0 !important
}
.md-container {
  min-width: 268px;
  padding: 0 !important
}
</style>
